import type { SendRecord } from './types';

export const sendRecords: SendRecord[] = [
  {
    id: 1000,
    notificationItem: '订单支付通知',
    content: '尊敬的用户，您的订单已支付成功！订单号：202401150001，支付金额：￥299.00，云电脑配置：8核16G，使用期限：30天。感谢您的购买，祝您使用愉快！',
    method: 'sms',
    userName: '张三',
    phone: '138****5678',
    email: 'zhang***@example.com',
    status: 'success',
    sendTime: '2024-01-28 10:23:15'
  },
  {
    id: 1001,
    notificationItem: '订单支付通知',
    content: '尊敬的用户，您的订单已支付成功！订单号：202401150002，支付金额：￥599.00，云电脑配置：16核32G，使用期限：30天。感谢您的购买，祝您使用愉快！',
    method: 'email',
    userName: '李四',
    phone: '139****1234',
    email: 'lisi***@example.com',
    status: 'success',
    sendTime: '2024-01-28 10:25:32'
  },
  {
    id: 1002,
    notificationItem: '云电脑到期提醒',
    content: '尊敬的用户，您的云电脑（ID：CPC-20240115-001）将于3天后到期。为避免影响您的正常使用，请及时续费。如有疑问，请联系客服。',
    method: 'sms',
    userName: '王五',
    phone: '136****9876',
    email: 'wang***@example.com',
    status: 'success',
    sendTime: '2024-01-28 09:15:20'
  },
  {
    id: 1003,
    notificationItem: '注册/登录验证码',
    content: '您的验证码是：123456，该验证码5分钟内有效，请勿泄露给他人。如非本人操作，请忽略此消息。',
    method: 'sms',
    userName: '赵六',
    phone: '137****5432',
    email: 'zhao***@example.com',
    status: 'success',
    sendTime: '2024-01-28 11:30:45'
  },
  {
    id: 1004,
    notificationItem: '余额不足提醒',
    content: '尊敬的用户，您的账户余额不足50元，当前余额：￥35.80。为保证您的云电脑正常运行，建议您及时充值。点击链接立即充值。',
    method: 'email',
    userName: '孙七',
    phone: '135****7890',
    email: 'sun***@example.com',
    status: 'failed',
    sendTime: '2024-01-28 08:45:12'
  },
  {
    id: 1005,
    notificationItem: '退款完成通知',
    content: '尊敬的用户，您的退款申请已处理完成。订单号：202401140005，退款金额：￥299.00，预计1-3个工作日到账。如有疑问，请联系客服。',
    method: 'sms',
    userName: '周八',
    phone: '133****2468',
    email: 'zhou***@example.com',
    status: 'success',
    sendTime: '2024-01-28 14:20:33'
  },
  {
    id: 1006,
    notificationItem: '云电脑释放通知',
    content: '尊敬的用户，您的云电脑（ID：CPC-20240110-008）已于今日到期并被系统自动释放。如需继续使用，请重新购买。感谢您的理解与支持！',
    method: 'email',
    userName: '吴九',
    phone: '132****1357',
    email: 'wu***@example.com',
    status: 'success',
    sendTime: '2024-01-28 00:05:18'
  },
  {
    id: 1007,
    notificationItem: '云存储不足提醒',
    content: '尊敬的用户，您的云电脑（ID：CPC-20240120-015）云存储使用率已达85%，剩余空间：15GB。建议您及时清理或扩容，以免影响使用。',
    method: 'sms',
    userName: '郑十',
    phone: '131****9753',
    email: 'zheng***@example.com',
    status: 'success',
    sendTime: '2024-01-28 16:40:27'
  },
  {
    id: 1008,
    notificationItem: '长期未登录唤醒通知',
    content: '亲爱的用户，我们发现您已经30天未登录系统了。我们为您准备了专属优惠活动，充值满500元即送50元！活动时间有限，快来看看吧！',
    method: 'email',
    userName: '冯十一',
    phone: '130****8642',
    email: 'feng***@example.com',
    status: 'success',
    sendTime: '2024-01-28 10:00:00'
  },
  {
    id: 1009,
    notificationItem: '注册/登录验证码',
    content: '您的验证码是：789012，该验证码5分钟内有效，请勿泄露给他人。如非本人操作，请忽略此消息。',
    method: 'sms',
    userName: '陈十二',
    phone: '188****3691',
    email: 'chen***@example.com',
    status: 'failed',
    sendTime: '2024-01-28 15:22:50'
  },
  {
    id: 1010,
    notificationItem: '云电脑释放提醒',
    content: '尊敬的用户，您的云电脑（ID：CPC-20240118-022）将于2天后因到期而被释放。请及时续费或备份重要数据，以免造成损失。',
    method: 'email',
    userName: '褚十三',
    phone: '187****2580',
    email: 'chu***@example.com',
    status: 'success',
    sendTime: '2024-01-28 09:30:15'
  },
  {
    id: 1011,
    notificationItem: '积分不足提醒',
    content: '尊敬的学校管理员，您的学校账户积分余额不足100分，当前余额：85分。为保证学生正常使用云电脑服务，建议您及时充值积分。',
    method: 'sms',
    userName: '卫十四',
    phone: '186****1479',
    email: 'wei***@example.com',
    status: 'success',
    sendTime: '2024-01-28 08:15:40'
  }
];
